import { gql } from '@apollo/client';

export const UPDATE_TRQK_SONG = gql`
    mutation updateTrqkSong($updatetrqksonginput: UpdateTrqkSongInput!) {
        updateTrqkSong(input: $updatetrqksonginput) {
            id
            audio_id
            user_id
            title
            statements
            performance_count
            percent_share
            earnings
            detection_count
            detections {
                detection_duration
                detection_start
                detection_time
                market
                song_id
                station_name
            }
            detection_status
            work_ids
            shows
        }
    }
`;
